import React, { useEffect, useRef, useState } from 'react';
import { deleteItem } from 'cms/utils/Network';
import { ApiHttpService } from 'cms/utils/http/api';

export default function VideoGalleryItemController(item, onDelete) {

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [feature_loading, setFeatureLoading] = useState(false);
  const [is_featured, setIsFeatured] = useState(item.is_featured);

  const closeModal = () => {
    setModalIsOpen(false)
  }

  const _delete = () => {
    deleteItem(`api/usergallery`, item.id);
    closeModal()
    onDelete(item.id)
  }

  const _changeFeatured = () => {
    setFeatureLoading(true)
    setIsFeatured(!is_featured)

    ApiHttpService.saveUserGalleryFeatured(item.id,!item.is_featured).then(data => {
      setFeatureLoading(false)
    })
  }



  return {
    modalIsOpen,
    setModalIsOpen,
    _delete,
    _changeFeatured,
    is_featured, setIsFeatured
  };;
}
